import axiosClient from "./axiosClient";

const paymentCodeRoute = "nanoId/generate-code";

export const getPaymentCode = async () => {
  try {
    const response = await axiosClient.get(`${paymentCodeRoute}`);
    return response;
  } catch (error) {
    console.error(error);
  }
};
